module.exports = __webpack_public_path__ + "static/img/50-1.f49cbf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/50-1.jpg
// module id = zcRy
// module chunks = 0